import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebase/client";
import type { BroadcastLiveState } from "../types/broadcasts.types";

export function useBroadcastScore(broadcastId: string | null): BroadcastLiveState {
	const [state, setState] = useState<BroadcastLiveState>({ homeScore: 0, awayScore: 0, varReview: false, createdAt: null, endedAt: null });

	useEffect(() => {
		if (!broadcastId) return;

		const unsubscribe = onSnapshot(doc(db, "broadcasts", broadcastId), (snap) => {
			if (snap.exists()) {
				const data = snap.data();
				setState({
					homeScore: data.homeScore ?? 0,
					awayScore: data.awayScore ?? 0,
					varReview: data.varReview ?? false,
					createdAt: data.createdAt ?? null,
					endedAt: data.endedAt ?? null,
				});
			}
		});

		return unsubscribe;
	}, [broadcastId]);

	return state;
}
